import { render, staticRenderFns } from "./Declaration.vue?vue&type=template&id=085aaf42&scoped=true&"
import script from "./Declaration.vue?vue&type=script&lang=js&"
export * from "./Declaration.vue?vue&type=script&lang=js&"
import style0 from "./Declaration.vue?vue&type=style&index=0&id=085aaf42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085aaf42",
  null
  
)

export default component.exports